// extracted by mini-css-extract-plugin
module.exports = {"reservationBtns":"reservationBtns_reservationBtns__Uq_Av","reservation":"reservationBtns_reservation__i7ouO"};